import { useParams } from "react-router";

import { RiskModelEditor } from "./risk-model-editor";

export default function RiskModelEditorPage() {
  const { id } = useParams();
  return <RiskModelEditor id={id!} />;
}
